import React from 'react';
import {Icon, IconProps} from "@chakra-ui/react";

const BackIcon = (props: IconProps) => (
    <Icon xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" strokeWidth="2" stroke="#2c3e50" fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M5 12l14 0"/>
        <path d="M5 12l6 6"/>
        <path d="M5 12l6 -6"/>
    </Icon>
)

export default BackIcon;